/* eslint-disable angular/window-service, max-len */
if (!window.customElements) {
  document.write(
    '<script src="https://cdnjs.cloudflare.com/ajax/libs/document-register-element/1.7.2/document-register-element.js"></script>'
  );
}
/* eslint-enable angular/window-service, max-len */
